function BilledStatus() {
  return (
    <div className="w-[84px] h-[22px] flex items-center justify-center rounded-[11px] bg-wo_color6 font-OpenSansRegular font-[400] text-titleColor text-[10px]">
      BILLED
    </div>
  );
}

export default BilledStatus;
